"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerms = exports.InventoryOrderType = exports.InventoryOrderStatus = void 0;
/**
 * Status of the purchase/transfer/ds order.
 * //TODO: add delivery statuses as separate enum and field in order
 */
var InventoryOrderStatus;
(function (InventoryOrderStatus) {
    /** Order is a draft and can be modified freely */
    InventoryOrderStatus["DRAFT"] = "draft";
    /** Order is confirmed */
    InventoryOrderStatus["PENDING"] = "pending";
    /** Cancelled before being shipped */
    InventoryOrderStatus["CANCELLED"] = "cancelled";
    /** Order is completed */
    InventoryOrderStatus["RECEIVED"] = "received";
})(InventoryOrderStatus = exports.InventoryOrderStatus || (exports.InventoryOrderStatus = {}));
var InventoryOrderType;
(function (InventoryOrderType) {
    InventoryOrderType["DROPSHIPPING"] = "dropshipping";
    InventoryOrderType["TRANSFER"] = "transfer";
    InventoryOrderType["PURCHASE_ORDER"] = "purchase_order";
})(InventoryOrderType = exports.InventoryOrderType || (exports.InventoryOrderType = {}));
/**A snapshot of the product data when it was added to the order */
var PaymentTerms;
(function (PaymentTerms) {
    PaymentTerms["NONE"] = "none";
    PaymentTerms["IN_ADVANCE"] = "in_advance";
    PaymentTerms["ON_RECEIPT"] = "on_receipt";
    PaymentTerms["NET_7"] = "net_7";
    PaymentTerms["NET_15"] = "net_15";
    PaymentTerms["NET_30"] = "net_30";
    PaymentTerms["NET_45"] = "net_45";
    PaymentTerms["NET_60"] = "net_60";
})(PaymentTerms = exports.PaymentTerms || (exports.PaymentTerms = {}));
